<template>
    <div class="marketplace-weekly-section">
        <v-container>
            <h2 class="section-title mb-6">ขายดีประจำสัปดาห์</h2>

            <!-- Loading Skeleton -->
            <div v-if="loading" class="weekly-scroll-container">
                <div class="scroll-wrapper">
                    <div class="d-flex flex-nowrap py-2" style="min-width: min-content;">
                        <div v-for="n in 6" :key="'skel-' + n" class="px-2 weekly-col-wrapper">
                            <div class="skeleton-item">
                                <v-skeleton-loader type="image, list-item-two-line" class="skeleton-loader" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Error State -->
            <div v-else-if="error" class="text-center py-6 text-grey">
                <v-icon size="40" color="grey-lighten-1">mdi-alert-circle-outline</v-icon>
                <p class="mt-2">ไม่สามารถโหลดข้อมูลได้</p>
            </div>

            <!-- Empty State -->
            <div v-else-if="!items.length" class="text-center py-6 text-grey">
                <v-icon size="40" color="grey-lighten-1">mdi-package-variant</v-icon>
                <p class="mt-2">ยังไม่มีสินค้าขายดีในสัปดาห์นี้</p>
            </div>

            <!-- Product Scroll -->
            <div v-else class="weekly-scroll-container">
                <v-btn icon class="nav-btn prev-btn" @click="scrollPrev" variant="elevated" size="small">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <div class="scroll-wrapper" ref="scrollContainer">
                    <div class="d-flex flex-nowrap py-2" style="min-width: min-content;">
                        <div v-for="(item, index) in items" :key="item.id" class="px-2 weekly-col-wrapper">
                            <WeeklyProductCard :product="item" :rank="index" />
                        </div>
                    </div>
                </div>

                <v-btn icon class="nav-btn next-btn" @click="scrollNext" variant="elevated" size="small">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-container>
    </div>
</template>

<script>
import { getWeeklyBestSellersApi } from "@/services/api/product";
import WeeklyProductCard from "./WeeklyProductCard.vue";

export default {
    name: "MarketplaceWeekly",
    components: {
        WeeklyProductCard
    },
    data() {
        return {
            items: [],
            loading: true,
            error: false,
        };
    },
    async mounted() {
        await this.fetchWeeklyBestSellers();
    },
    methods: {
        async fetchWeeklyBestSellers() {
            this.loading = true;
            this.error = false;
            try {
                const res = await getWeeklyBestSellersApi(10);
                this.items = res.data || [];
            } catch (e) {
                console.error("fetchWeeklyBestSellers error:", e);
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
        scrollPrev() {
            this.$refs.scrollContainer.scrollBy({ left: -300, behavior: "smooth" });
        },
        scrollNext() {
            this.$refs.scrollContainer.scrollBy({ left: 300, behavior: "smooth" });
        },
    },
};
</script>

<style scoped>
.marketplace-weekly-section {
    padding: 20px 0 40px;
    max-width: 1440px;
    margin: 0 auto;
}

.section-title {
    font-size: 24px;
    font-weight: 700;
    color: #2E7D32;
}

/* Scroll Container */
.weekly-scroll-container {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 28px;
}

.scroll-wrapper {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-behavior: smooth;
    width: 100%;
}

.scroll-wrapper::-webkit-scrollbar {
    display: none;
}

/* Nav buttons */
.nav-btn {
    background-color: #fff !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
    position: absolute;
    z-index: 2;
}

.prev-btn {
    left: -4px;
}

.next-btn {
    right: -4px;
}

/* Flex wrapper for scrolling elements */
.weekly-col-wrapper {
    width: clamp(140px, 40vw, 220px);
    flex-shrink: 0;
}

@media (max-width: 600px) {
    .marketplace-weekly-section {
        padding: 16px 0 28px;
    }

    .section-title {
        font-size: 18px;
    }

    .weekly-scroll-container {
        padding: 0 20px;
    }

    .weekly-col-wrapper {
        width: clamp(130px, 42vw, 180px);
    }
}

/* Skeleton */
.skeleton-item {
    aspect-ratio: 1;
    width: 100%;
}

.skeleton-loader {
    height: 100%;
    border-radius: 20px;
}
</style>
